// ------------------------------------------------------------
// TODOs:
// - [ ] complete two-column filter menu
// - [ ] complete location & timezone filters
// - [x] read team list from DB (getting profiles at their `lastPublishTs` (from Fauna's temporality feature))
// - [ ] password reset
// - [ ] timezones (and how it relates to the "Flexible schedule" and "No off-hour expectations" benefits)
// - [x] only salary positions??? A: No.
// - [ ] create "browse by" pages (i.e. browse by team attribute, browser by benefit, etc)
// - [ ] use a link on master such as "beta list member invitation?" that leads to the initial team onboarding funnel
// - [ ] Rather than having "technology" be a filter in the search bar, have it as a label on profile pages (and maybe in the listings...) that
//       is clickable and goes to a "tag" listing page (e.g. "VueJS" where clicking it goes to a page listing all teams using "VueJS")
// - [x] make profile responsive
// - [ ] make index responsive
// - [ ] ensure all aspects of site are mobile friendly
// - [ ] Add consistent form validation
// - [ ] Add user permissions and UI for managing them
// - [ ] Handle profile new (not profile edit)
// - [x] Create an index for all published profiles (for getting the published profiles from on build)
//       Get it by looking for a `lastPublishTs` on each profile, then getting each of those profiles at that timestamp (via Fauna's temporality feature).
// - [x] On profile publish, call "buddy" (build service) endpoint to rebuild the site.
// - [x] Update examples of team names with those here: https://basecamp.com/handbook/06-orgchart#core-product
//       - Core product
//       - Mobile
//       - Customer Support
//       - Design
//       - etc
// - [x] Build-out company-level support
// - [ ] Create location-based pricing (consider using https://dev.maxmind.com/geoip/geoip2/geolite2/)
// - [x] Fix bug in profile tiptap editor where changing the `optionKey` of an existing entry clears the content. The issue is in the `watch` handler in `EditorTipTap.vue`
// - [ ] Complete all CRUD support in account section
// - [ ] Re-work the way location (work from) data is stored and presented.
//       - Always show continent/subcontinent names, showing number of countries in that continent, e.g. `North America (4/7)` OR `North America (all)`
//       - Use tooltip for listing countries in that continent
//       - Sort the continents alphabetically (in profile)
// - [x] Consider making the dynamics required and always having the same order on the profile page. From a job-seekers perspective this is maybe preferrable (as they're assured that all the teams)
//       have given answers/explanations to these questions. That seems like maybe a strong marketing/selling point for the project.
// - [x] Consider combining "weekly schedule" and "daily schedule" dynamics into, simply, "schedule"?
// COMPANY
// - [ ] Edit company info (should handle redirects...)
// TEAM
// - [ ] Edit team info (should handle redirects...)
// - [ ] Add user
// - [ ] Add team (finish polishing the flow... should be able to add to existing company or add a new one in the flow... default to company from where the button was clicked, if there is one)
// - [ ] Select plan
// - [ ] Add payment method (is this necessary?)
// - [ ] Show billing history (if this is one)... need to wait on this until Stripe is wired up
// - [ ] Delete team (handle also conditionally deleting company)
// PERSONAL
// - [ ] Change email
// - [ ] Reset password (CONSIDERATION: Just use magic link auth... drop the password. Would be a lot simpler. Any downsides?)

// ------------------------------------------------------------
// CONSIDERATIONS (before initial launch):
// - [ ] Consideration: Some type of way to notify the user when their publish has gone live (state indicator in the UI? email? other?)
// - [ ] Use Netlify's JS API for deploying the site to speed up the deploy process.
// - [ ] Document data schema in single place
// - [x] Modularize profile sections
// - [ ] Consider adding a "Qualifications" top-level filter section. Possible things to include:
//       - college degree: `required CS related`, `required (any)`, `non required`
//       - experience:
// - [ ] Add an "Education" section to the "Hiring for" filter
// - [ ] Add a "click to zoom" feature for images in the "Dynamics" section. Not sure whether this should always be added or be toggleable (or whether it's necessary at all)...
// ------------------------------------------------------------
// CONSIDERATIONS (after initial launch):
// - [ ] A Q&A section on the profile page
//       - teams create the Q&As
//       - users can submit questions (perhaps optionally, where each team can disable this ability)
//       [Alternatively/Additionally] Instead, add a Q&A component to the editor in the dynamics section (for Q&A entries in the context of each dynamic)
// - [ ] Use https://github.com/tangbc/vue-virtual-scroll-list for handling the list (for better performance on large lists...)
// - [ ] Add ability to "diff" changes in the editor
// - [ ] Only show relevant primary technologies based on position's role
// ------------------------------------------------------------
// DONE:
// - [x] decide on name
// - [x] Make account section responsive
// - [x] make master effectively a landing page with an email list signup
// - [x] continue development on a dev branch
// - [x] authentication
// - [x] Wire-up date handling library
// - [x] Wire-up tooltip library
// - [x] wire up filtering (including query params)
// - [x] job-type filtering (industry level, position level, other???)
// - [x] Use team ID (or maybe profile ID?) for directory name in digital ocean (rather than team name)... this prevents it from having to be
//       updated (or else going stale) if/when a team changes their name. This also enables us to (optionally) hard-code image paths in the data (though we probably don't want to do this)
// ------------------------------------------------------------

import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import DefaultLayout from './layouts/Default.vue'

import VueMeta from 'vue-meta'
import './styles/main.sass'
import store from './store'
// import AsyncComputed from 'vue-async-computed'
import VueStaticData from 'vue-static-data'
import Snotify, { SnotifyPosition } from 'vue-snotify' // toaster notifications
import { format as formatDate, getYear, isThisYear } from 'date-fns'
import VueTippy, { TippyComponent } from 'vue-tippy'
// // import VueSwal from 'vue-swal' // modal alerts and such
import Loading from './components/Loading.vue'
// import LoadingInline from './components/LoadingInline.vue'
import Vuelidate from 'vuelidate'
import 'tippy.js/themes/light.css'
import * as util from './util'
import VueCurrencyFilter from 'vue-currency-filter'
//
import dataCountriesByContinent from '~/../../s-dataStatic/countries-by-continent.json'
import timezonesUTC from '~/../../s-dataStatic/timezonesUTC.json'

function mapCountriesByContinentToCountries() {
   const countries = dataCountriesByContinent.map(item => item.children)
   const countriesFlat = [].concat.apply([], countries)
   return countriesFlat
}

const countries = mapCountriesByContinentToCountries()
const countriesByContinent = dataCountriesByContinent
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

// // export default function(Vue, { router, head, appOptions, isClient, isServer }) {
// Vue.directive('scrollAddClass', function (el, binding, vnode) {
//    // https://vuejs.org/v2/guide/custom-directive.html
//    var hasClass = false
//    var offset = binding.value.offset || 0
//    let f = function (evt) {
//       if (hasClass !== vnode.elm.getBoundingClientRect().top <= offset) {
//          hasClass = !hasClass
//          vnode.elm.classList.toggle(binding.value.toggleClass)
//       }
//    }
//    if (process.isClient) {
//       window.addEventListener('scroll', f)
//    }
// })

// // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

Vue.component('Layout', DefaultLayout)
Vue.component('Loading', Loading)
// Vue.component('LoadingInline', LoadingInline)

Vue.use(VueMeta, {
   // optional pluginOptions
   //   refreshOnceOnNavigation: true
})

Vue.use(VueStaticData)
Vue.use(Vuelidate)
// Vue.use(AsyncComputed)
// // docs: https://artemsky.github.io/vue-snotify/documentation/index.html
Vue.use(Snotify, {
   toast: {
      position: SnotifyPosition.rightBottom,
      closeClick: true,
      timeout: 3250,
   },
})
// // Vue.use(VueSwal) // haven't yet used this but it looks like the best for modal confirms, dialongs, etc
Vue.use(VueTippy, {
   directive: 'tippy', // => v-tippy
   flipDuration: 0,
   theme: 'light',
   animateFill: false,
   popperOptions: {
      modifiers: {
         preventOverflow: {
            enabled: false,
         },
         hide: {
            enabled: false,
         },
      },
   },
})
Vue.component('tippy', TippyComponent)

// // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

Vue.filter('removeDashes', function (string) {
   return string.replace(/-/g, ' ')
})

Vue.filter('titleCase', function (string) {
   return string && string.charAt(0).toUpperCase() + string.substring(1)
})

Vue.filter('truncate', function (text, stop, suffix) {
   return text.substring(0, stop) + (suffix ? suffix : '')
})

Vue.filter('defaultDateTime', function (dSrc) {
   // shows the year if the year is in the past
   if (!dSrc) return

   let d = dSrc
   if (typeof dSrc === 'number') {
      // The current `ts` from fauna is type `number` and an epoch time to the precission of microseconds (though they plan to switch this to use nanoseconds in the future).
      //- JS uses milliseconds for datetime.
      //- The default UNIX epoch uses seconds.
      //- Converting the `ts` value to milliseconds converts it to something JS can convert into a date object.
      d = new Date(dSrc * 0.001)
   }

   const maybeYear = isThisYear(new Date(d)) ? '' : ` ${getYear(new Date(d))}`
   return `${formatDate(new Date(d), 'MMM d')}${maybeYear}, at ${formatDate(new Date(d), 'h:mm a')}`
})

Vue.filter('defaultDate', function (dSrc) {
   // shows the year if the year is in the past
   if (!dSrc) return

   let d = dSrc
   if (typeof dSrc === 'number') {
      // The current `ts` from fauna is type `number` and an epoch time to the precission of microseconds (though they plan to switch this to use nanoseconds in the future).
      //- JS uses milliseconds for datetime.
      //- The default UNIX epoch uses seconds.
      //- Converting the `ts` value to milliseconds converts it to something JS can convert into a date object.
      d = new Date(dSrc * 0.001)
   }

   const maybeYear = isThisYear(new Date(d)) ? '' : ` ${getYear(new Date(d))}`
   return `${formatDate(new Date(d), 'MMM d')}${maybeYear}`
})

Vue.use(VueCurrencyFilter, {
   symbol: '$',
   thousandsSeparator: ',',
   fractionCount: 0,
   fractionSeparator: '.',
   symbolPosition: 'front',
   symbolSpacing: false
})

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

Vue.mixin({
   methods: {
      ...util,
      getAttrPropByOptionKey({ attrSrc, optionKey, prop = 'label' }) {
         if (!attrSrc) return
         const attr = attrSrc.find(attr => attr.optionKey === optionKey)
         return attr && attr[prop]
      },
      getAttrPropByAttrKey({ attrSrc, attrKey, prop = 'label' }) {
         if (!attrSrc) return
         const attr = attrSrc.find(attr => attr.attrKey === attrKey)
         return attr && attr[prop]
      },
      getPropFromAttrOption({ attrSrc, attrKey, optionKey, prop = 'label' }) {
         // Note: args.attrKey is optional – should be used if needing a nested lookup, otherwise omit it
         const attr = attrKey ? attrSrc.find(attr => attr.attrKey === attrKey) : attrSrc
         const option = attr && attr.options.find(option => option.optionKey === optionKey)
         return option && option[prop]
      },
      objectInArrayContains(arrayToSearch, prop, value) {
         const mappedArray = arrayToSearch.map(arr => arr[prop])
         return mappedArray && mappedArray.length && mappedArray.includes(value)
      },
      isUpperCase(str) {
         return str === str.toUpperCase()
      },
      getCountryLabelById(id) {
         return countries.find(country => country.id === id)
      },
      getCountriesByContinent(continentId) {
         return countriesByContinent.find(continent => continent.id === continentId)
      },
      getUtcOffset(date) {
         let offset = date.getTimezoneOffset() / 60
         return (offset > 0 ? '-' : '+') + offset
      },
      getCurrentUtcOffset() {
         const now = new Date()
         return this.getUtcOffset(now)
      },
      getTimeUtcItem(offset) {
         return timezonesUTC.find(item => item.offset === offset)
      },
      getUtcTimezoneItemsBetween(minOffset, maxOffset) {
         const min = timezonesUTC.findIndex(item => item.offset === minOffset)
         const max = timezonesUTC.findIndex(item => item.offset === maxOffset)
         return timezonesUTC.slice(min, max + 1)
      },
   },
})

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

// root-scope data, not stored in localstorage
// access properties via `this.$root.VAR`

// TODO: Check to make sure this still works (used to be `appOptions.data`)

Vue.data = {
   verificationEmailResent: false,
   currentYear: (function () {
      const today = new Date()
      return today.getFullYear()
   })(),
}

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

new Vue({
   router,
   store,
   render: h => h(App)
}).$mount("#app")
